module.exports = __webpack_public_path__ + "static/media/truffle-mobile-fr.4f6f8049.jpg";